import type { Panel } from '@/types/panels'

export const getSectionModulus = (panel: Panel): number => {
  if (panel.section_modulus_per_width) {
    return panel.section_modulus_per_width
  }
  if (panel.moment_of_inertia && panel.neutral_axis && panel.width) {
    return panel.moment_of_inertia / panel.neutral_axis / panel.width
  }
  return 0
}

// Z-Pile panels under Panel.z_pile_section_modulus_per_width_limit come first;
// the API flags them, since the limit is in cm3/m and the search may be in in3/ft.
export const zPileFirst = (a: Panel, b: Panel): number =>
  Number(!a.z_pile_promoted) - Number(!b.z_pile_promoted)

export const isExactMatch = (panelValue: number, searchValue: number): boolean => {
  const tolerance = 0.5
  return Math.abs(panelValue - searchValue) <= tolerance
}

export const getPanelImage = (panel: Panel): string | undefined => {
  return panel.banner_image ?? undefined
}
